export default __webpack_public_path__ + "static/media/Pot3.63359b15.svg";